<template>
  <v-simple-table class="date_view_table">
    <tr v-for="(item, index) in data" v-bind:key="index">
      <td
        @click="choose(b)"
        v-for="(b, index) in item"
        v-bind:key="index"
        v-bind:class="
          b.found
            ? b.status == 1
              ? 'selected'
              : 'selected-not-go'
            : 'not-selected'
        "
      >
        <ul>
          {{
            b.date
          }}
        </ul>
      </td>
    </tr>
    <visit-date-detail
      @close="detailShow = false"
      v-bind:show="detailShow"
      v-bind:detailData="detailData"
    ></visit-date-detail>
  </v-simple-table>
</template>

<script>
import Detail from "./Detail.vue";
export default {
  props: ["dates"],
  data() {
    return {
      detailData: null,
      detailShow: false,
    };
  },
  methods: {
    checkInExist(currentDate) {
      //var go = false;
      //var status;
      // this.visit_dates.map(val => {
      //     if (val.date == currentDate.date) {
      //         go = true;
      //         status = val.status;
      //     }
      // });
      // if (go) {
      return {
        date: currentDate.date,
        choose: true,
        status: true,
      };
      // } else {
      //     return null;
      // }
    },
    choose(item) {
      if (item.found) {
        this.detailData = item.data;
        this.detailShow = true;
      }
    },
  },
  components: {
    "visit-date-detail": Detail,
  },
  computed: {
    data() {
      var filterDate = [];
      var arr = [];
      this.dates.map((val, index) => {
        arr.push(val);
        var number = parseInt(index) + 1;
        if (number % 7 == 0) {
          filterDate.push(arr);
          arr = [];
        }
      });
      //var leftLength = this.dates.length - filterDate.length;
      var bb = [];
      for (var i = filterDate.length * 7; i < this.dates.length; i++) {
        bb.push(this.dates[i]);
      }
      filterDate.push(bb);
      filterDate.map((val) => {
        val.map((val) => {
          var returnData = this.checkInExist(val);
          if (returnData) {
            val.choose = returnData.choose;
            val.status = returnData.status;
          }
        });
      });
      return filterDate;
    },
  },
};
</script>

<style scoped>
.date_view_table td {
  padding: 10px !important;
}
td {
  font-size: 18px !important;
  text-align: center;
}
td.selected {
  background: blue;
  color: white;
}
td.selected-not-go {
  background: red;
  color: white;
}
ul {
  list-style-type: none;
}
</style>
